module.exports = __webpack_public_path__ + "img/btn_google_play.a1045ce9.svg";